<template>
  <div class="container" @click="onClick()">
    <div class="icon"></div>
    <div class="text">
      {{ converting ? "PPT转换中..." : getText("导入PPT") }}
    </div>
    <div class="tag"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      input: null,
      locked: false,
      draftId: "",
      tid: "",
      converting: false,
      aborted: false, // 因为文件大小或类型中断上传ppt
      clickShowMask: false, // 点击按钮是否打开mask
      convertResult: "", // 'done' | 'fail'
    };
  },
  computed: {
    ...mapGetters(["TopnavMsg", "UserMsg", "UserEquity", "isPersonVip"]),
  },
  watch: {
    "TopnavMsg.isShowPptMask": {
      handler(val) {
        if (!val && !this.converting) {
          this.clickShowMask = false;
        }
      },
    },
  },
  created() {
    setTimeout(() => {
      // this.toggleMask(true);
      // this.$bus.emit('pptConvertDone');
      // this.$modal.show('vipDialog', {
      //   msg: '您的视频导出权益次数已使用完毕,请购买资源包或是升级企业协作版可无限使用!',
      //   target: 'vipsolo',
      //   type: 'vip.s',
      //   bottomLink: '/vip',
      //   bottomLinkTarget: '',
      //   bottomLinkText: '作品容量无限制,点击了解高级会员。',
      // });
    }, 2000);
    this.$bus.on("upload_vue", (data) => {
      if (data.type === "ppt") {
        this.onPPTUploaded({
          filename: data.data.filename,
          title: (data.file.name || "").replace(/\.(.*)?$/, ""),
        });
      }
    });

    this.$bus.on("pptAbort", () => {
      this.locked = false;
      this.aborted = true;
    });
    this.$bus.on("pptCancelConvert", () => {
      this.cancelConvert();
    });
    // upload start
    this.$bus.on("upLoadingDown_vue", (data) => {
      // 把开始上传作为转换ppt的起点
      if (data.type === 0 && data.dataType === "ppt") {
        this.toggleMask(true);
        this.converting = true;
        this.clickShowMask = true;
        this.convertResult = "";
        this.$bus.emit("pptConnected", false);
      }
    });
    // upload error
    this.$bus.on("upLoadingDown_vue", (data) => {
      if (data.type === 1 && data.dataType === "ppt") {
        this.toggleMask(true);
        this.$bus.emit("pptConvertFail");
        this.locked = false;
        this.converting = false;
        this.clickShowMask = false;
        this.convertResult = "fail";
        this.aborted = true;
      }
    });
    this.$bus.on("pptNewDraft", () => {
      this.toggleMask(false);
      this.clickShowMask = false;
    });
  },
  mounted() {
    this.assignInputEl();
    this.input.addEventListener("change", (ev) => {
      if (!this.aborted) {
        this.locked = true;
      } else {
        this.aborted = false;
      }
      this.unbindFocus();
    });
  },
  methods: {
    getText(text) {
      let temp = text;
      if (this.convertResult && this.clickShowMask) {
        this.convertResult === "done" && (temp = "PPT转换成功");
        this.convertResult === "fail" && (temp = "PPT转换失败");
      }
      return temp;
    },
    getLimit(type) {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/api/user/limit?type=" + type)
          .then((res) => {
            resolve(res.data.data || {});
          })
          .catch((err) => {
            console.warn(err);
            resolve({});
          });
      });
    },
    async checkVip() {
      let popupShowed;
      let transformRemain = this.UserMsg.transformRemain;
      // let dWork = await this.getLimit("work");
      let dDraft = await this.getLimit("draft");

      // let pass = transformRemain > 0 && !dWork.exceed && !dDraft.exceed;

      if (dDraft.exceed) {
        popupShowed = true;
        this.$memberGuide({
          show: true,
          context: this,
          funcRight: {
            type: "draftNumber",
            name: "草稿数量",
          },
        });
      }
      // if (this.isPersonVip || this.UserMsg.level === 0) {
      //   // solo
      // }
      return popupShowed;
    },
    async onClick() {
      let popupShowed = await this.checkVip();
      if (popupShowed) {
        return;
      }
      this.checkVip();
      if (this.clickShowMask) {
        this.toggleMask(true);
        if (!this.converting && this.convertResult) {
          this.convertResult === "done" && this.$bus.emit("pptConvertDone");
          this.convertResult === "fail" && this.$bus.emit("pptConvertFail");
        }
        return;
      }
      if (this.locked) {
        return;
      }
      this.locked = true;

      this.assignInputEl();
      this.bindFocus();
      this.input.click();
    },
    onPPTUploaded({ filename = "", title = "" } = {}) {
      this.$http
        .post("/api/user/draft/ppt", {
          filename,
          title,
        })
        .then((res) => {
          if (!res.data.data) {
            // 关联时出错
            this.locked = false;
            this.converting = false;
            this.convertResult = "fail";
            this.toggleMask(true);
            this.$bus.emit("pptConvertFail");
            this.clickShowMask = false;

            this.$message({
              type: "error",
              message: "抱歉，你的文件上传失败，请尝试重新上传！",
            });
            return;
          }
          let draftId = res.data.data.projectId;
          this.draftId = draftId;
          this.$bus.emit("pptConnected", true);
          this.checkConvert();
          // 开始上传ppt文件的时候就打开了，这里不用打开了
          // this.toggleMask(true);
        })
        .catch((err) => {
          console.warn("err", err);
          this.locked = false;
          this.toggleMask(true);
          this.$bus.emit("pptConvertFail");
        });
    },
    checkConvert() {
      console.log('888888888888');
      this.$http
        .get(`/api/user/draft?id=${this.draftId}`)
        .then((res) => {
          let data = res.data.data;
          let { ppt, isPass, id } = data;
          // console.log("TCL: checkConvert -> ppt, isPass", ppt, isPass)
          if (ppt != null && isPass == 0) {
            clearInterval(this.tid);
            this.$bus.emit("pptConvertDone");
            this.onConvertDone(id);
            this.convertResult = "done";
            // setTimeout(() => {
            //   this.toggleMask(false);
            // }, 3000);
            this.locked = false;
          } else if (isPass == 2) {
            clearInterval(this.tid);
            // this.$message({
            //   type: 'error',
            //   message: '转换PPT失败，请重试'
            // });
            // this.toggleMask(true);
            this.$bus.emit("pptConvertFail");
            this.convertResult = "fail";
            this.locked = false;
            this.converting = false;
          } else {
            this.tid = setTimeout(() => {
              this.checkConvert();
            }, 1000);
          }
        })
        .catch((err) => {
          console.warn("err", err);
          this.convertResult = "fail";
          this.locked = false;
          this.converting = false;
          // this.toggleMask(false);
          this.$bus.emit("pptConvertFail");
        });
    },
    onConvertDone(draftId) {
      // let el = $('<a></a>')
      //   .prop({target: '_blank', href: `${location.origin}${location.pathname}#/${draftId}`})
      // el[0].click();
      this.$store.commit("save_PPTDraftId", draftId);
      this.converting = false;

      if (this.TopnavMsg.isShowPptMask) {
        this.clickShowMask = false;
      }
    },
    toggleMask(show) {
      this.$store.commit("save_TopnavMsg", {
        isShowPptMask: show,
      });
    },
    cancelConvert() {
      this.$http
        .post("/api/user/draft/cancelPpt", {
          id: this.draftId,
        })
        .then((res) => {
          clearTimeout(this.tid);
          this.toggleMask(false);
          this.locked = false;
          this.converting = false;
          this.clickShowMask = false;
        });
    },
    bindFocus(isUnbind) {
      const vm = this;
      if (isUnbind) {
        window.removeEventListener("focus", this.handler);
        this.handler = null;
        return;
      }
      this.handler =
        this.handler ||
        function h() {
          window.removeEventListener("focus", h);
          vm.assignInputEl();
          vm.locked = false;
        };
      window.addEventListener("focus", this.handler);
    },
    unbindFocus() {
      return this.bindFocus(true);
    },
    assignInputEl() {
      const vm = this;
      if (!vm.input) {
        vm.input = document.getElementById("ppt");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 45px;
  background-color: #5778fb;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.26);
  border-radius: 4px;
  transition-duration: 0.3s;
  cursor: pointer;

  &:hover {
    .icon {
      background-image: url(../../../static/img/ppt-2.png);
    }
    .text {
      font-size: 14px;
    }
  }
}

.icon {
  width: 27px;
  height: 29px;
  background-size: 100% 100%;
  background-image: url(../../../static/img/ppt-1.png);
}

.text {
  padding-left: 1em;
  color: #ffffff;
  font-weight: bold;
  font-size: 12px;
  transition-duration: 0.3s;
}

.tag {
  position: absolute;
  top: 0;
  right: 0;
  width: 41px;
  height: 29px;
  background-size: 100% 100%;
  background-image: url(../../../static/img/ppt-new.png);
}
</style>



// WEBPACK FOOTER //
// src/components/scenes/fromPPT.vue